/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * TK-38 việc 4 (lee 23/10) — trang "Quản lý đèn" (`/den-nema`): trái CÂY Tuyến → Tủ → Đèn (sổ xuống, tìm), phải Ô THÔNG TIN
 *   của mục đang chọn (tuyến · tủ · đèn). Mục đang chọn sống trong URL (`?tuyen=&tu=&den=`) — chép link là mở đúng chỗ.
 *   Đọc MỘT API (`/api/nema/cay`, phạm vi tài khoản). Thay bảng "tủ có đèn" của TK-35 lượt 2.
 * Luật: mất kết nối XÁM; số chưa có ⇒ "—"; I hiện mA; không mã kỹ thuật trên cây (mã đèn chỉ để tìm).
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EmptyState, ErrorBox, Spinner } from '../components/ui';
import { useCayDen } from '../lib/nemaApi';
import { tenDen } from '../lib/nemaNhan';
import { useDatDoiTuong } from '../lib/doiTuongDangChon';
import { CayDen, type ChonCay } from '../components/quanlyden/CayDen';
import { ODen, OTu, OTuyen } from '../components/quanlyden/OThongTin';

export default function DenNemaPage() {
  const q = useCayDen();
  const [thamSo, datThamSo] = useSearchParams();
  useEffect(() => { document.title = 'Quản lý đèn — SDKD'; }, []);
  const denTs = thamSo.get('den');
  const chon: ChonCay = { tuyen: thamSo.get('tuyen'), tu: thamSo.get('tu'), den: denTs !== null && denTs !== '' && Number.isInteger(Number(denTs)) ? Number(denTs) : null };
  /* TK-45 §2: thanh đáy — mục đang chọn trên cây (tuyến › tủ › đèn) */
  const cayDt = q.data ?? [];
  const rDt = cayDt.find((x) => x.id === chon.tuyen) ?? (chon.tu ? cayDt.find((x) => x.tu.some((y) => y.id === chon.tu)) : undefined);
  const tDt = chon.tu ? rDt?.tu.find((x) => x.id === chon.tu) : undefined;
  const dDt = tDt && chon.den !== null ? tDt.den.find((d) => d.addr === chon.den) : undefined;
  useDatDoiTuong({ tuyen: rDt?.tenDayDu, tu: tDt?.name, den: dDt ? tenDen(dDt) : null });
  const onChon = (c: ChonCay) => {
    const p: Record<string, string> = {};
    if (c.tuyen) p.tuyen = c.tuyen; if (c.tu) p.tu = c.tu; if (c.den !== null) p.den = String(c.den);
    datThamSo(p);
  };
  if (q.isLoading) return <Spinner label="Đang tải…" />;
  if (q.isError) return <ErrorBox error={q.error} onRetry={() => void q.refetch()} />;
  const cay = q.data ?? [];
  const r = cay.find((x) => x.id === chon.tuyen) ?? (chon.tu ? cay.find((x) => x.tu.some((t) => t.id === chon.tu)) : undefined) ?? null;
  const t = chon.tu ? r?.tu.find((x) => x.id === chon.tu) ?? null : null;
  const soDen = cay.reduce((n, x) => n + x.tu.reduce((m, y) => m + y.soDen, 0), 0);
  return (
    <div className="flex flex-col gap-4" data-o="trang-den-nema">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="m-0 text-xl font-semibold text-chu-1">Quản lý đèn</h1>
        <span className="text-sm text-chu-2">{cay.length} tuyến · {soDen} đèn</span>
      </div>
      {cay.length === 0 ? <EmptyState title="Chưa có tủ nào có đèn" hint="Tủ hiện ở đây sau khi nhận đèn." /> : (
        <div className="grid grid-cols-[minmax(0,1fr)] gap-4 lg:grid-cols-[320px_minmax(0,1fr)]">
          <CayDen cay={cay} chon={chon} onChon={onChon} />
          <div className="min-w-0" data-o="o-thong-tin">
            {t && chon.den !== null ? <ODen key={`${t.id}:${chon.den}`} t={t} addr={chon.den} />
              : t ? <OTu key={t.id} t={t} />
              : r ? <OTuyen r={r} />
              : <p className="m-0 rounded-the border border-vien bg-nen-1 p-6 text-center text-sm text-chu-3">Chọn tuyến, tủ hoặc đèn</p>}
          </div>
        </div>
      )}
    </div>
  );
}
